/**
 * Created by sunjinyu on 2018/11/13.
 */
/* eslint-disable */
Date.prototype.Format = function (fmt) { //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};

export const Utils = {
  setLocal: function (cname, value) {
    let oldLocal = localStorage.getItem(cname);
    if (oldLocal) {
      var spliceArr = oldLocal.split(',');
      // 如果Local里面不包含此订单，就存取
      if (!spliceArr.includes(value)) {
        // 如果Local订单大于等于10个就删除第一个订单号
        if (spliceArr.length >= 10) {
          spliceArr.shift()
        };
        // 如果Local的长度大于1 就拼接字符存取
        let newValue = spliceArr.join(',') + ',' + value;
        localStorage.setItem(cname, newValue)
        return
      } else {
        return ''
      }
    } else {
      localStorage.setItem(cname, value)
    }
  },
  getLocal: function (cname) {
    let oldLocal = localStorage.getItem(cname);
    return oldLocal
  },
  getLocalLast: function (cname) {
    var oldLocal = localStorage.getItem(cname);
    if (oldLocal) {
      var newArr = localStorage.getItem(cname).split(',');
      if (newArr.length > 1) {
        for (let [index, elem] of newArr.entries()) {
          if (index === newArr.length - 1) {
            return elem
          }
        }
      } else {
        return oldLocal
      }
    } else {
      return ''
    }
  },
  setLanguage (name, value) {
    localStorage.setItem(name, value);
  },
  trim0: function(value) {
    return value.replace(/(^\s*)|(\s*$)/g, '');
  }
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/utils/patch.js